<template>
    <div class="form-group" v-if="!isPaidByGiftCertificate">
        <div class="title">
            <h2>Select Payment Method</h2>
        </div>
        <div class="payment-method-container">
            <fieldset>
                <legend class="sr-only">Set payment method information</legend>
                <template v-for="(paymentMethod, index) in getAvailableDesktopPaymentMethods">
                    <component :is="paymentMethod.component" :payment-method="paymentMethod"></component>
                    <template v-if="index < getAvailableDesktopPaymentMethods.length - 1">
                        <div class="divider"><span>OR</span></div>
                    </template>
                </template>
            </fieldset>
        </div>
    </div>
</template>

<script>
    import {mapGetters} from "vuex";
    import ExpressCheckout from "@app/components/checkout/components/expressCheckout";

    export default {
        name: 'desktopPaymentMethods',
        components: {ExpressCheckout},
        props: {},
        computed: {
            ...mapGetters('checkout', [
                'checkout',
                'isPaidByGiftCertificate',
                'getAvailableDesktopPaymentMethods',
                'selectedDesktopPaymentMethod'
            ]),
        },
        inject: [
            "$validator"
        ],
    }
</script>
